import { Component } from 'react';
import HabitModule from './HabitModule';
import HabitForm from '../forms/HabitForm';
import { FormReveal } from './Animations';
import { makeBEM } from '../global/utils';
import { LABELS } from '../global/constants';
import Icon from '../atoms/Icon';
import { GeneralObserver } from './Observer';

class HabitsModule extends Component {

	constructor(props) {
		super(props);
		this.state = {
			boardID: this.props.parentID,
			controller: this.props.controller,
			habits: [],
			showForm: false,
		}

		this.observer = false;
		this.moduleName = 'habits';
		this.showFormBtnClass = `btn--icon btn--icon-and-text ${makeBEM(this.moduleName, 'show-form-btn')}`;

		this.bindFunctions();
	}
	
	bindFunctions() {
		this.reactFn = this.reactFn.bind(this);
		this.deleteHabit = this.deleteHabit.bind(this);
		this.showFormBtnClick = this.showFormBtnClick.bind(this);
        this.discardForm = this.discardForm.bind(this);
	}

	componentDidMount() {
		this.initialSetup();
	}

	// Setup observer and subscribe to events from controller
    // Fetch data from controller 
	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);

		ctrl.addObserver(this.observer);
		ctrl.fetchData();

		this.setState({
			controller: ctrl,
		});
	}

	// Reacts to controller events
	// Sets controller and habits
	reactFn() {
		const ctrl = this.state.controller;
		const newData = ctrl.getHabits();

		this.setState({
			controller: ctrl,
			habits: newData
		})
	}

	// Takes in id and calls controller delete fn
	deleteHabit(id=-1) {
		if ( id !== -1 ) {
			const ctrl = this.state.controller;
			ctrl.delete(id);
		}
	}

	// Toggles HabitForm visibility by negating showForm state
	toggleFormVisibility() {
        const formShown = this.state.showForm;

        this.setState({
            showForm: !formShown
        });
    }

	// Show form btn event handler
	// Calls toggleFormVisibility
	showFormBtnClick() {
        this.toggleFormVisibility();
    }

	// Discard form event handler
	// Calls toggleFormVisibility
	discardForm() {
        this.toggleFormVisibility();
    }

	// Renders dummy content while reloading
	renderDummyContent() {
		return (
			<div>
				<div className="habit dummy">
					<p className="habit__title-and-days-done-wrapper">
						<span className="habit__title shimmer"></span>
						<span className="habit__days-done shimmer"></span>
					</p>
					<div className="streak-dates habit-dates shimmer"></div>
					<div className="habit__streak-btn shimmer"></div>
				</div>
				<div className="habit dummy">
					<p className="habit__title-and-days-done-wrapper">
						<span className="habit__title shimmer"></span>
						<span className="habit__days-done shimmer"></span>
					</p>
					<div className="streak-dates habit-dates shimmer"></div>
					<div className="habit__streak-btn shimmer"></div>
				</div>
			</div>
		);
	}

	render() {
		const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

		const reloading = this.props.reloading;
		const renderContent = !reloading;
		const showFormBtn = !reloading;

		const habits = ctrl.getHabits();
		const hasHabits = habits && habits.length > 0;
		const showForm = this.state.showForm;		

		return (
	    		<div className={ this.moduleName }>

					{ reloading &&
						this.renderDummyContent()
					}

	    			{hasHabits && renderContent &&
						Object.keys(habits).map(key => (
						<HabitModule 
							data={habits[key]}
							key={habits[key].id} 
							animate={ habits[key].animate }
							deleteAction={this.deleteHabit}
						/>
					))}

					{
						showFormBtn &&
						<div className="board__form-btn">
							<button
								className={ this.showFormBtnClass }
								onClick={ this.showFormBtnClick  }
							>
								<Icon name="plus"/>{LABELS.newHabit}
							</button>
						</div>
					}
					
					{
						showForm &&
						<FormReveal>
							<HabitForm
								boardID={this.state.boardID} 
								discardForm={this.discardForm}
								controller={ctrl}
							/>
						</FormReveal>
					}

		    	</div>
	    );
  	}
}

export default HabitsModule;
